import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { OFFER_EDIT, OFFER_TABS } from '../../../../constants/OfferConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import OfferDetails from './Offer-Details';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import { offerSelector } from '../../cmsSlice';

const OfferView = (props) => {
  const { offer, toggleDrawer, onViewToggle, permissions, getOffersType } = props;
  const cmsOffer = useSelector(offerSelector);
  const [tabValue, setTabValue] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(offer);

  useEffect(() => {
    if (cmsOffer.length) {
      const currOffer = cmsOffer.find((o) => o.id === offer.id);
      setSelectedOffer(currOffer);
    }
  }, [cmsOffer, offer.id]);

  const isOfferStatusCompleted = selectedOffer?.status === 'Completed';

  // Disable edit option for completed offers
  const isOfferEditable =
    permissions[RBAC_TYPE_CMS_OFFERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS &&
    !isOfferStatusCompleted;

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedOffer);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(OFFER_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <OfferDetails tabValue={tabValue} offer={selectedOffer} getOffersType={getOffersType} />;
  };

  return (
    <>
      {selectedOffer && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={OFFER_TABS}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedOffer.createdBy}
          isEditable={isOfferEditable}
          isHeightIncluded={true}
          title={selectedOffer.name}
          tabClass='col-md-10'
        />
      )}
    </>
  );
};

export default OfferView;
